/**
 * Bonne Nuit theme behaviors: order tracking dropdown, category carousel,
 * marquee pause helpers, mobile menu, scroll-to-top, predictive search.
 */
(function () {
  'use strict';

  function qs(sel, root) {
    return (root || document).querySelector(sel);
  }

  function qsa(sel, root) {
    return Array.from((root || document).querySelectorAll(sel));
  }

  /* ---------- Money ----------
   * The store's money format setting is "{{amount}}TL", which Shopify renders
   * in the English style: 1,599.00TL. Prices are written here instead so the
   * shopper always reads 1.599,00 TL, whatever the setting says.
   */
  var bnParaBicimi = null;
  function bnPara(cents, kurusuYaz) {
    var tutar = Number(cents || 0) / 100;
    if (!isFinite(tutar)) tutar = 0;
    var basamak = kurusuYaz === false ? 0 : 2;
    try {
      if (!bnParaBicimi) {
        bnParaBicimi = new Intl.NumberFormat('tr-TR', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        });
      }
      if (basamak === 0) {
        return new Intl.NumberFormat('tr-TR', {
          minimumFractionDigits: 0,
          maximumFractionDigits: 0
        }).format(tutar) + ' TL';
      }
      return bnParaBicimi.format(tutar) + ' TL';
    } catch (e) {
      return tutar.toFixed(basamak).replace('.', ',') + ' TL';
    }
  }
  window.bnPara = bnPara;

  /* ---------- Order tracking dropdown ---------- */
  function initOrderTracking() {
    qsa('[data-bn-order-toggle]').forEach(function (btn) {
      var panelId = btn.getAttribute('aria-controls');
      var panel = panelId ? document.getElementById(panelId) : null;
      if (!panel) return;

      var captchaRoot = qs('[data-bn-captcha-root]', panel);
      var captchaApi = null;
      function ensureCaptcha() {
        if (captchaApi || !window.BNOrderTrack || !captchaRoot) return captchaApi;
        captchaApi = window.BNOrderTrack.bindCaptcha(captchaRoot);
        return captchaApi;
      }

      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var open = panel.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (open) ensureCaptcha();
      });

      var form = qs('[data-bn-order-dropdown-form]', panel);
      if (form && form.dataset.bnCaptchaBound !== 'true') {
        form.dataset.bnCaptchaBound = 'true';
        form.addEventListener('submit', function (e) {
          var api = ensureCaptcha();
          var values = api ? api.getValues() : { token: '', answer: '' };
          if (!values.token || !values.answer) {
            e.preventDefault();
            alert('Lütfen güvenlik sorusunu cevaplayın.');
            if (api) api.load();
            return;
          }
          // Native GET carries captcha_token + captcha_answer to the tracking page.
        });
      }
    });

    document.addEventListener('click', function (e) {
      qsa('.bn-order-dropdown.is-open').forEach(function (panel) {
        if (!panel.contains(e.target) && !e.target.closest('[data-bn-order-toggle]')) {
          panel.classList.remove('is-open');
          var toggle = document.querySelector('[aria-controls="' + panel.id + '"]');
          if (toggle) toggle.setAttribute('aria-expanded', 'false');
        }
      });
    });
  }

  /* ---------- Mobile menu drawer ---------- */
  function initMobileMenu() {
    qsa('[data-bn-header]').forEach(function (header) {
      if (header.dataset.bnMenuBound === 'true') return;
      header.dataset.bnMenuBound = 'true';

      var openBtn = qs('[data-bn-menu-open]', header);
      var drawer = qs('[data-bn-menu-drawer]', header);
      var overlay = qs('[data-bn-menu-overlay]', header);
      var headerBar = qs('[data-bn-header-bar]', header);
      var scrollEl = qs('[data-bn-menu-scroll]', drawer) || drawer;
      var moreEl = qs('[data-bn-menu-more]', drawer);
      if (!drawer || !openBtn) return;

      function syncMenuPosition() {
        if (!headerBar) return;
        var bottom = headerBar.getBoundingClientRect().bottom;
        document.documentElement.style.setProperty('--bn-menu-top', bottom + 'px');
      }

      function syncMenuMore() {
        if (!moreEl || !scrollEl) return;
        var canScroll = scrollEl.scrollHeight > scrollEl.clientHeight + 8;
        var nearBottom = scrollEl.scrollTop + scrollEl.clientHeight >= scrollEl.scrollHeight - 12;
        var show = canScroll && !nearBottom;
        moreEl.hidden = !show;
        moreEl.setAttribute('aria-hidden', show ? 'false' : 'true');
        drawer.classList.toggle('has-more', show);
      }

      function open() {
        syncMenuPosition();
        header.classList.add('bn-header--menu-open');
        drawer.classList.add('is-open');
        drawer.setAttribute('aria-hidden', 'false');
        if (overlay) overlay.classList.add('is-open');
        openBtn.setAttribute('aria-expanded', 'true');
        openBtn.setAttribute('aria-label', 'Menüyü kapat');
        document.documentElement.classList.add('bn-menu-open');
        requestAnimationFrame(function () {
          syncMenuMore();
        });
      }

      function close() {
        header.classList.remove('bn-header--menu-open');
        drawer.classList.remove('is-open');
        drawer.setAttribute('aria-hidden', 'true');
        if (overlay) overlay.classList.remove('is-open');
        openBtn.setAttribute('aria-expanded', 'false');
        openBtn.setAttribute('aria-label', 'Menüyü aç');
        document.documentElement.classList.remove('bn-menu-open');
        if (moreEl) {
          moreEl.hidden = true;
          moreEl.setAttribute('aria-hidden', 'true');
        }
        drawer.classList.remove('has-more');
      }

      scrollEl.addEventListener(
        'scroll',
        function () {
          if (drawer.classList.contains('is-open')) syncMenuMore();
        },
        { passive: true }
      );

      function toggleMenu(e) {
        if (e) {
          e.preventDefault();
          e.stopPropagation();
        }
        if (drawer.classList.contains('is-open')) close();
        else open();
      }

      openBtn.addEventListener('click', toggleMenu);

      if (overlay) overlay.addEventListener('click', close);

      document.addEventListener('click', function (e) {
        if (!drawer.classList.contains('is-open')) return;
        if (drawer.contains(e.target) || openBtn.contains(e.target)) return;
        close();
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
      });

      window.addEventListener('resize', function () {
        syncMenuPosition();
        if (drawer.classList.contains('is-open')) syncMenuMore();
      });
      window.addEventListener(
        'scroll',
        function () {
          if (drawer.classList.contains('is-open')) syncMenuPosition();
        },
        { passive: true }
      );
    });
  }

  /* ---------- Predictive search ---------- */
  function initPredictiveSearch() {
    var placeholderSrc = window.__bnPlaceholderLogo || '';

    qsa('[data-bn-predictive-search]').forEach(function (root) {
      var input = qs('[data-bn-search-input]', root);
      var results = qs('[data-bn-search-results]', root);
      if (!input || !results) return;
      // Header re-renders in the editor call this again; don't stack listeners.
      if (root.dataset.bnPredictiveBound === 'true') return;
      root.dataset.bnPredictiveBound = 'true';

      var timer = null;
      var controller = null;

      function hideResults() {
        results.hidden = true;
        results.innerHTML = '';
        input.setAttribute('aria-expanded', 'false');
      }

      function renderProducts(products) {
        if (!products.length) {
          results.innerHTML = '<p class="bn-predictive-search-dropdown__empty">Sonuç bulunamadı.</p>';
          results.hidden = false;
          input.setAttribute('aria-expanded', 'true');
          return;
        }

        var html = '<div class="bn-predictive-search-dropdown"><ul class="bn-predictive-search-dropdown__list list-unstyled">';
        products.forEach(function (product) {
          var image = '';
          if (product.featured_image && product.featured_image.url) {
            image = product.featured_image.url;
          } else if (typeof product.image === 'string') {
            image = product.image;
          } else if (product.image && product.image.url) {
            image = product.image.url;
          }

          var imageHtml = image
            ? '<img src="' + image + '" alt="" class="bn-predictive-search-dropdown__thumb" width="48" height="48" loading="lazy">'
            : '<img src="' + placeholderSrc + '" alt="" class="bn-predictive-search-dropdown__thumb bn-predictive-search-dropdown__thumb--placeholder" width="48" height="48" loading="lazy">';

          html +=
            '<li><a href="' +
            product.url +
            '" class="bn-predictive-search-dropdown__item">' +
            imageHtml +
            '<span class="bn-predictive-search-dropdown__title">' +
            product.title +
            '</span></a></li>';
        });
        html += '</ul></div>';

        results.innerHTML = html;
        results.hidden = false;
        input.setAttribute('aria-expanded', 'true');
      }

      function fetchResults(term) {
        if (controller) controller.abort();
        controller = new AbortController();

        var url =
          '/search/suggest.json?q=' +
          encodeURIComponent(term) +
          '&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=hide';

        fetch(url, { signal: controller.signal })
          .then(function (res) {
            return res.json();
          })
          .then(function (data) {
            var products = (data.resources && data.resources.results && data.resources.results.products) || [];
            renderProducts(products);
          })
          .catch(function (err) {
            if (err.name !== 'AbortError') hideResults();
          });
      }

      input.addEventListener('input', function () {
        var term = input.value.trim();
        clearTimeout(timer);

        if (!term.length) {
          hideResults();
          return;
        }

        timer = setTimeout(function () {
          fetchResults(term);
        }, 200);
      });

      input.addEventListener('focus', function () {
        if (input.value.trim().length) fetchResults(input.value.trim());
      });

      document.addEventListener('click', function (e) {
        if (!root.contains(e.target)) hideResults();
      });

      input.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') hideResults();
      });
    });
  }

  /* ---------- Mobile search toggle ---------- */
  function initMobileSearch() {
    qsa('[data-bn-header]').forEach(function (header) {
      if (header.dataset.bnMobileSearchBound === 'true') return;
      header.dataset.bnMobileSearchBound = 'true';

      var toggle = qs('[data-bn-search-toggle]', header);
      var panel = qs('[data-bn-search-panel]', header);
      if (!toggle || !panel) return;
      var input = qs('[data-bn-search-input]', panel);

      function setOpen(open) {
        panel.hidden = !open;
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (open && input) input.focus();
      }

      // No stopPropagation: the menu drawer's own document listener should still
      // see this click and close the drawer when search opens.
      toggle.addEventListener('click', function (e) {
        e.preventDefault();
        setOpen(panel.hidden);
      });

      document.addEventListener('click', function (e) {
        if (panel.hidden) return;
        if (panel.contains(e.target) || toggle.contains(e.target)) return;
        setOpen(false);
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !panel.hidden) {
          setOpen(false);
          toggle.focus();
        }
      });
    });
  }

  /* ---------- Logo fallback for broken CDN uploads ---------- */
  function initLogoFallback() {
    qsa('[data-bn-logo-fallback]').forEach(function (img) {
      var fallback = img.getAttribute('data-bn-logo-fallback');
      if (!fallback) return;

      img.addEventListener('error', function () {
        if (img.dataset.bnLogoFailed === 'true') return;
        img.dataset.bnLogoFailed = 'true';
        img.removeAttribute('srcset');
        img.src = fallback;
      });
    });
  }

  /* ---------- Category carousel ---------- */
  function initCarousels() {
    qsa('[data-bn-carousel]').forEach(function (root) {
      if (root.dataset.bnCarouselBound === 'true') return;
      root.dataset.bnCarouselBound = 'true';

      var track = qs('[data-bn-carousel-track]', root);
      var slides = qsa('[data-bn-carousel-slide]', root);
      if (!track || slides.length === 0) return;

      var prev = qs('[data-bn-carousel-prev]', root);
      var next = qs('[data-bn-carousel-next]', root);
      var autoplay = root.getAttribute('data-autoplay') !== 'false';
      var interval = parseInt(root.getAttribute('data-interval') || '2500', 10);
      var index = 0;
      var timer = null;
      var pointerStartX = null;

      function perView() {
        return window.matchMedia('(max-width: 767px)').matches
          ? parseInt(root.getAttribute('data-mobile') || '1', 10)
          : parseInt(root.getAttribute('data-desktop') || '2', 10);
      }

      function maxIndex() {
        return Math.max(0, slides.length - perView());
      }

      function go(i) {
        index = Math.max(0, Math.min(i, maxIndex()));
        var slideWidth = slides[0].getBoundingClientRect().width;
        var gap = parseFloat(getComputedStyle(track).gap) || 0;
        track.style.transform = 'translateX(-' + index * (slideWidth + gap) + 'px)';
      }

      function nextSlide() {
        if (index >= maxIndex()) go(0);
        else go(index + perView());
      }

      function prevSlide() {
        if (index <= 0) go(maxIndex());
        else go(index - perView());
      }

      function start() {
        if (!autoplay || slides.length <= perView()) return;
        stop();
        timer = setInterval(nextSlide, interval);
      }

      function stop() {
        if (timer) clearInterval(timer);
        timer = null;
      }

      if (prev) prev.addEventListener('click', function () { prevSlide(); start(); });
      if (next) next.addEventListener('click', function () { nextSlide(); start(); });
      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', start);
      root.addEventListener('focusin', stop);
      root.addEventListener('focusout', start);
      root.addEventListener('pointerdown', function (event) {
        pointerStartX = event.clientX;
        stop();
      });
      root.addEventListener('pointerup', function (event) {
        if (pointerStartX === null) return;
        var distance = event.clientX - pointerStartX;
        pointerStartX = null;
        if (Math.abs(distance) > 40) {
          if (distance < 0) nextSlide();
          else prevSlide();
        }
        start();
      });
      root.addEventListener('pointercancel', function () {
        pointerStartX = null;
        start();
      });
      window.addEventListener('resize', function () { go(index); });
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) stop();
        else start();
      });

      go(0);
      start();
    });
  }

  /* ---------- Scroll to top ---------- */
  function initScrollTop() {
    var btn = qs('[data-bn-scroll-top]');
    if (!btn) return;

    window.addEventListener(
      'scroll',
      function () {
        if (window.scrollY > 400) btn.classList.add('is-visible');
        else btn.classList.remove('is-visible');
      },
      { passive: true }
    );

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  /* ---------- Sticky header ---------- */
  function initStickyHeader() {
    var header = qs('[data-bn-header]');
    var bar = qs('[data-bn-header-bar]');
    if (!header || !bar) return;

    var spacer = document.createElement('div');
    spacer.className = 'bn-header__spacer';
    spacer.setAttribute('aria-hidden', 'true');
    header.appendChild(spacer);

    function sync() {
      var h = bar.offsetHeight;
      spacer.style.height = header.classList.contains('is-sticky') ? h + 'px' : '0px';
      document.documentElement.style.setProperty('--bn-header-sticky-h', h + 'px');
    }

    window.addEventListener(
      'scroll',
      function () {
        if (window.scrollY > 10) header.classList.add('is-sticky');
        else header.classList.remove('is-sticky');
        sync();
      },
      { passive: true }
    );

    window.addEventListener('resize', sync);
    sync();
  }

  /* ---------- Entrance and section reveal motion ---------- */
  function initPageMotion() {
    window.requestAnimationFrame(function () {
      document.body.classList.remove('bn-motion-pending');
      document.body.classList.add('bn-motion-ready');
    });
  }

  function initSectionReveal() {
    /* Disabled: whole-section opacity:0 hid tall homepage blocks. */
  }

  /* ---------- Featured product cards: staggered upward reveal ---------- */
  function initProductCardReveal(root) {
    var scope = root || document;
    var cards = qsa('.bn-featured-products__item.bn-card-reveal', scope);
    if (!cards.length) return;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
      cards.forEach(function (card) {
        card.classList.add('is-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -6% 0px', threshold: 0.12 }
    );

    cards.forEach(function (card) {
      if (card.classList.contains('is-visible')) return;
      observer.observe(card);
    });
  }

  /* ---------- Product page gallery zoom ---------- */
  function initGalleryZoom(gallery) {
    var stage = qs('.bn-product-gallery__stage', gallery);
    if (!stage) return function () {};

    var mql = window.matchMedia('(hover: hover) and (min-width: 992px)');

    var state = {
      zoomImg: null,
      slide: null,
      factorX: 0,
      factorY: 0,
      displayW: 0,
      displayH: 0
    };

    function clearZoom() {
      if (state.zoomImg) {
        state.zoomImg.remove();
        state.zoomImg = null;
      }
      if (state.slide) {
        state.slide.classList.remove('is-zooming');
      }
      state.slide = null;
    }

    function computeFactors() {
      if (!state.zoomImg || !state.slide) return false;

      state.displayW = state.slide.offsetWidth;
      state.displayH = state.slide.offsetHeight;
      if (!state.displayW || !state.displayH) return false;

      var zoomW = state.zoomImg.offsetWidth;
      var zoomH = state.zoomImg.offsetHeight;
      if (zoomW <= state.displayW || zoomH <= state.displayH) {
        clearZoom();
        return false;
      }

      state.factorX = (zoomW - state.displayW) / state.displayW;
      state.factorY = (zoomH - state.displayH) / state.displayH;
      return true;
    }

    function moveZoom(clientX, clientY) {
      if (!state.zoomImg || !state.slide) return;

      var rect = state.slide.getBoundingClientRect();
      var x = Math.max(0, Math.min(clientX - rect.left, state.displayW));
      var y = Math.max(0, Math.min(clientY - rect.top, state.displayH));

      state.zoomImg.style.left = -x * state.factorX + 'px';
      state.zoomImg.style.top = -y * state.factorY + 'px';
    }

    function startZoom(slide, baseImg, clientX, clientY) {
      var zoomSrc = baseImg.getAttribute('data-zoom-src') || baseImg.currentSrc || baseImg.src;
      if (!zoomSrc) return;

      clearZoom();
      state.slide = slide;

      var zoomImg = document.createElement('img');
      zoomImg.className = 'bn-product-gallery__zoom-img';
      zoomImg.alt = '';
      zoomImg.src = zoomSrc;

      zoomImg.addEventListener('load', function () {
        zoomImg.style.width = zoomImg.naturalWidth + 'px';
        zoomImg.style.height = zoomImg.naturalHeight + 'px';
        if (!computeFactors()) return;
        slide.classList.add('is-zooming');
        moveZoom(clientX, clientY);
      });

      slide.appendChild(zoomImg);
      state.zoomImg = zoomImg;
    }

    function syncZoomMode() {
      if (mql.matches) {
        stage.classList.add('bn-product-gallery__stage--zoom');
      } else {
        stage.classList.remove('bn-product-gallery__stage--zoom');
        clearZoom();
      }
    }

    stage.addEventListener('mousemove', function (e) {
      if (!mql.matches) {
        clearZoom();
        return;
      }

      if (e.target.closest('.bn-product-gallery__nav')) {
        clearZoom();
        return;
      }

      var slide = qs('.bn-product-gallery__slide.is-active', stage);
      if (!slide) return;

      var baseImg = qs('.bn-product-gallery__img:not(.bn-product-gallery__img--placeholder)', slide);
      if (!baseImg) return;

      if (!state.zoomImg || state.slide !== slide) {
        startZoom(slide, baseImg, e.clientX, e.clientY);
      } else if (slide.classList.contains('is-zooming')) {
        moveZoom(e.clientX, e.clientY);
      }
    });

    stage.addEventListener('mouseleave', clearZoom);
    window.addEventListener('resize', clearZoom);

    if (typeof mql.addEventListener === 'function') {
      mql.addEventListener('change', syncZoomMode);
    } else if (typeof mql.addListener === 'function') {
      mql.addListener(syncZoomMode);
    }

    syncZoomMode();

    return clearZoom;
  }

  /* ---------- Product page gallery, variants, add to cart modal ---------- */
  function initProductPage() {
    qsa('[data-bn-product]').forEach(function (root) {
      var jsonEl = qs('[data-bn-product-json]', root);
      var form = qs('[data-bn-product-form]', root);
      if (!jsonEl || !form) return;

      var product = null;
      try {
        product = JSON.parse(jsonEl.textContent || '{}');
      } catch (e) {
        return;
      }

      var variantInput = qs('[data-bn-variant-id]', form);
      var priceWhole = qs('[data-bn-price-whole]', root);
      var priceFrac = qs('[data-bn-price-frac]', root);
      var priceCompare = qs('[data-bn-price-compare]', root);
      var headAmount = qs('[data-bn-head-amount]', root);
      var headCompare = qs('[data-bn-head-compare]', root);
      var submitBtn = qs('[data-bn-add-to-cart]', form);
      var errorEl = qs('[data-bn-product-error]', form);
      var modal = qs('[data-bn-cart-modal]', root);
      if (modal && modal.parentElement !== document.body) {
        document.body.appendChild(modal);
      }
      var optionSelects = qsa('[data-bn-option-select]', form);

      function formatMoney(cents) {
        return bnPara(cents);
      }

      function splitPrice(cents) {
        var decimal = String(cents % 100).padStart(2, '0');
        return {
          // Binlik ayırıcı olmadan "1599" yazıyordu.
          whole: bnPara(Math.floor(cents / 100) * 100, false).replace(' TL', ''),
          frac: ',' + decimal + ' TL'
        };
      }

      function findVariant() {
        if (!product.variants || !product.variants.length) return null;
        if (optionSelects.length === 0) return product.variants[0];

        var selected = optionSelects.map(function (select) {
          return select.value;
        });

        return product.variants.find(function (variant) {
          return variant.options.every(function (opt, idx) {
            return opt === selected[idx];
          });
        });
      }

      function updateVariantUI(variant) {
        if (!variant || !variantInput) return;

        variantInput.value = variant.id;
        var split = splitPrice(variant.price);
        if (priceWhole) priceWhole.textContent = split.whole;
        if (priceFrac) priceFrac.textContent = split.frac;
        if (priceWhole && priceWhole.closest('[data-bn-product-price]')) {
          priceWhole
            .closest('[data-bn-product-price]')
            .setAttribute('data-bn-price-cents', String(variant.price));
        }

        if (headAmount) headAmount.textContent = bnPara(variant.price, variant.price % 100 !== 0);
        if (headCompare) {
          var headOnSale = variant.compare_at_price && variant.compare_at_price > variant.price;
          headCompare.hidden = !headOnSale;
          headCompare.textContent = headOnSale ? formatMoney(variant.compare_at_price) : '';
        }

        if (priceCompare) {
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            priceCompare.hidden = false;
            priceCompare.textContent = formatMoney(variant.compare_at_price);
          } else {
            priceCompare.hidden = true;
            priceCompare.textContent = '';
          }
        }

        if (submitBtn) {
          submitBtn.textContent = variant.available
            ? submitBtn.getAttribute('data-label-available') || 'Sepete Ekle!'
            : submitBtn.getAttribute('data-label-soldout') || 'Ürün tükendi';
          // Don't fight the scheduled-delivery widget gate — only force-disable
          // when the variant itself is unavailable.
          if (!variant.available) {
            submitBtn.disabled = true;
          } else {
            document.dispatchEvent(new CustomEvent('bn:variant-price', {
              detail: { cents: variant.price, available: true }
            }));
          }
        }
      }

      updateVariantUI(findVariant());

      optionSelects.forEach(function (select) {
        select.addEventListener('change', function () {
          updateVariantUI(findVariant());
        });
      });

      var editKey = getBnEditKey();
      if (editKey) {
        if (submitBtn) {
          submitBtn.textContent = 'Güncelle';
          submitBtn.setAttribute('data-label-available', 'Güncelle');
        }
        fetch(rootPath() + 'cart.js', { headers: { Accept: 'application/json' } })
          .then(function (res) {
            if (!res.ok) throw new Error('cart_get_failed');
            return res.json();
          })
          .then(function (cart) {
            var items = (cart && cart.items) || [];
            var line = null;
            for (var i = 0; i < items.length; i++) {
              if (items[i].key === editKey) {
                line = items[i];
                break;
              }
            }
            if (!line) {
              clearBnEditParam();
              return;
            }

            var snapshot = snapshotFromCartLine(line);
            prefillProductFormFromLine(form, product, line, snapshot);
            updateVariantUI(findVariant());

            var addonCandidates = [];
            items.forEach(function (it) {
              if (!it || it.key === editKey) return;
              if (isFeeLineItem(it)) return;
              if (hasScheduledDeliveryProps(it.properties)) return;
              addonCandidates.push({
                key: it.key,
                variantId: it.variant_id,
                // Carries "Rakam" so editing a line keeps the number the
                // shopper already typed for a rakam add-on.
                properties: it.properties || null
              });
            });
            BnCart.beginEdit(editKey, addonCandidates);

            // Persist snapshot so SCD can restore even if its listener
            // registers after this event (script load order).
            window.__bnScdPendingRestore = snapshot;
            if (window.BnScd && typeof window.BnScd.restore === 'function') {
              window.BnScd.restore(snapshot);
            } else {
              document.dispatchEvent(
                new CustomEvent('bn:scd:restore', { detail: snapshot })
              );
            }

            // Message card / custom fields may mount after widget config loads.
            document.addEventListener(
              'bn:scd:options-ready',
              function onOptionsReady() {
                prefillProductFormFromLine(form, product, line, snapshot);
                document.removeEventListener('bn:scd:options-ready', onOptionsReady);
              }
            );

            clearBnEditParam();
          })
          .catch(function (err) {
            console.warn('[BN] cart edit restore failed', err);
            clearBnEditParam();
          });
      }

      var gallery = qs('[data-bn-product-gallery]', root);
      if (gallery) {
        var slides = qsa('[data-bn-gallery-slide]', gallery);
        var thumbs = qsa('[data-bn-gallery-thumb]', gallery);
        var current = 0;
        var clearGalleryZoom = initGalleryZoom(gallery);

        function showSlide(index) {
          if (!slides.length) return;
          current = (index + slides.length) % slides.length;
          if (clearGalleryZoom) clearGalleryZoom();
          slides.forEach(function (slide, i) {
            slide.classList.toggle('is-active', i === current);
          });
          thumbs.forEach(function (thumb, i) {
            thumb.classList.toggle('is-active', i === current);
          });
        }

        var prevBtn = qs('[data-bn-gallery-prev]', gallery);
        var nextBtn = qs('[data-bn-gallery-next]', gallery);
        if (prevBtn) prevBtn.addEventListener('click', function () { showSlide(current - 1); });
        if (nextBtn) nextBtn.addEventListener('click', function () { showSlide(current + 1); });
        thumbs.forEach(function (thumb) {
          thumb.addEventListener('click', function () {
            showSlide(parseInt(thumb.getAttribute('data-index') || '0', 10));
          });
        });
      }

      function updateCartBadges(count) {
        qsa('.bn-header__badge').forEach(function (badge) {
          if (count > 0) {
            badge.textContent = String(count);
            badge.hidden = false;
          } else {
            badge.hidden = true;
          }
        });
      }

      function openModal() {
        if (!modal) return;
        modal.hidden = false;
        modal.setAttribute('aria-hidden', 'false');
        document.documentElement.classList.add('bn-cart-modal-open');
      }

      function closeModal() {
        if (!modal) return;
        modal.hidden = true;
        modal.setAttribute('aria-hidden', 'true');
        document.documentElement.classList.remove('bn-cart-modal-open');
      }

      if (modal) {
        qsa('[data-bn-cart-modal-close]', modal).forEach(function (el) {
          el.addEventListener('click', closeModal);
        });
        document.addEventListener('keydown', function (e) {
          if (e.key === 'Escape' && !modal.hidden) closeModal();
        });
      }

      initMessageCard(form);
      initDeliveryFeeDedupe(form);
      initDeliverySlotHelp(form);
      initDeliveryCopy(form);

      // Photo uploads (app-driven slots may appear after widget config loads).
      initProductPhotos(form);
      document.addEventListener('bn:photos-ready', function () {
        initProductPhotos(form);
      });

      form.addEventListener('submit', function (e) {
        // Scheduled delivery owns PDP add-to-cart (capture listener). If we
        // reach bubble phase with SCD required, do not AJAX-add without booking.
        var scd = document.querySelector('[data-scd-widget]:not([hidden])');
        if (scd && scd.getAttribute('data-scd-require') !== 'false') {
          e.preventDefault();
          return;
        }

        e.preventDefault();
        if (errorEl) {
          errorEl.hidden = true;
          errorEl.textContent = '';
        }

        var variant = findVariant();
        if (!variant || !variant.available) return;

        // Required custom fields (e.g. confirm checkbox) must be satisfied.
        var requiredEls = form.querySelectorAll('[data-bn-required]');
        for (var ri = 0; ri < requiredEls.length; ri++) {
          var rel = requiredEls[ri];
          var ok = (rel.type === 'checkbox' || rel.type === 'radio')
            ? rel.checked
            : String(rel.value || '').trim().length > 0;
          if (!ok) {
            var cerr = form.querySelector('[data-bn-custom-error]');
            if (cerr) cerr.hidden = false;
            return;
          }
        }

        // Collect line item properties (custom message, confirm, etc.).
        var lineProps = {};
        var propInputs = form.querySelectorAll('[name^="properties["]');
        Array.prototype.forEach.call(propInputs, function (el) {
          var m = el.name.match(/^properties\[(.+)\]$/);
          if (!m) return;
          var key = m[1];
          if (el.type === 'checkbox' || el.type === 'radio') {
            if (el.checked && String(el.value || '').trim()) lineProps[key] = el.value;
          } else {
            var v = String(el.value || '').trim();
            if (v) lineProps[key] = v;
          }
        });

        if (submitBtn) submitBtn.disabled = true;

        // A variant with no usable id makes Shopify refuse the request with
        // "geçerli kimlik veya satır parametresi yok", which reads to everyone
        // like a stock problem. Say what it is instead of sending it.
        if (!/^\d+$/.test(String(variant.id || ''))) {
          if (errorEl) {
            errorEl.hidden = false;
            errorEl.textContent = 'Ürün bilgisi yüklenemedi. Sayfayı yenileyip tekrar deneyin.';
          }
          if (submitBtn) submitBtn.disabled = false;
          return;
        }

        // Include checked add-on variants (populated by delivery widget).
        var items = [{
          id: Number(variant.id),
          quantity: 1,
          properties: Object.keys(lineProps).length ? lineProps : undefined
        }];
        qsa('.bn-addons__cb:checked', form).forEach(function (cb) {
          var row = cb.closest('.bn-addons__item');
          // Widget stores selection in its own map; theme path reads data attr if present.
          var vid = cb.getAttribute('data-variant-id');
          // One bad add-on id would take the whole line down with it.
          if (/^\d+$/.test(String(vid || ''))) items.push({ id: Number(vid), quantity: 1 });
        });

        fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({ items: items })
        })
          .then(function (res) {
            return res.json().then(function (data) {
              if (!res.ok) throw data;
              return data;
            });
          })
          .then(function () {
            // Edit mode: add new first, then remove the old line(s).
            var replace =
              BnCart.editSession && typeof BnCart.replaceEditLines === 'function'
                ? BnCart.replaceEditLines()
                : Promise.resolve(null);
            return replace.then(function () {
              document.dispatchEvent(
                new CustomEvent('bn:cart:updated', { detail: { open: true } })
              );
            });
          })
          .catch(function (err) {
            if (errorEl) {
              errorEl.hidden = false;
              errorEl.textContent =
                (err && err.description) || (err && err.message) || 'Sepete eklenirken bir hata oluştu.';
              // Somebody who cannot add to cart should reach a person, not the
              // back button. The number is the one the site already shows.
              var wa = document.querySelector('a[href*="wa.me/"]');
              if (wa) {
                errorEl.appendChild(document.createTextNode(' '));
                var help = document.createElement('a');
                help.href = wa.getAttribute('href');
                help.target = '_blank';
                help.rel = 'noopener';
                help.textContent = "WhatsApp'tan bize yazın, siparişinizi biz alalım.";
                errorEl.appendChild(help);
              }
            }
          })
          .finally(function () {
            if (submitBtn && variant.available) submitBtn.disabled = false;
          });
      });
    });
  }

  /* ---------- Add-on offers ----------
   * Add-on products are unlisted, so Liquid cannot read them out of the
   * collection. The app's proxy endpoint is the same source the product page
   * widget uses; the answer is kept for the session so opening the overlay a
   * second time costs nothing.
   */
  var BN_EK_URUN_UC = '/apps/scheduled-delivery/addons?handle=diger-urunler&take=48';
  // Bumped with `take`: sessions still hold the shorter v1 list.
  var BN_EK_URUN_ANAHTAR = 'bn_ek_urunler_v2';
  var bnEkUrunIstegi = null;

  function bnEkUrunleriGetir() {
    if (bnEkUrunIstegi) return bnEkUrunIstegi;
    try {
      var onbellek = sessionStorage.getItem(BN_EK_URUN_ANAHTAR);
      if (onbellek) {
        bnEkUrunIstegi = Promise.resolve(JSON.parse(onbellek));
        return bnEkUrunIstegi;
      }
    } catch (e) {
      /* private mode: just fetch */
    }
    bnEkUrunIstegi = fetch(BN_EK_URUN_UC, { headers: { Accept: 'application/json' } })
      .then(function (r) {
        return r.ok ? r.json() : { products: [] };
      })
      .then(function (data) {
        var urunler = (data && data.products) || [];
        try {
          sessionStorage.setItem(BN_EK_URUN_ANAHTAR, JSON.stringify({ products: urunler }));
        } catch (e) {
          /* storage full or blocked, not worth failing over */
        }
        return { products: urunler };
      })
      .catch(function () {
        // A missing offer must never look like a broken page.
        bnEkUrunIstegi = null;
        return { products: [] };
      });
    return bnEkUrunIstegi;
  }

  function bnSepettekiVaryantlar() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .then(function (cart) {
        var set = {};
        ((cart && cart.items) || []).forEach(function (it) {
          set[String(it.variant_id)] = true;
        });
        return set;
      })
      .catch(function () {
        return {};
      });
  }

  /** Add one add-on variant to the cart, keeping the shopper where they are. */
  function bnEkUrunEkle(urun, rakam) {
    var satir = { id: Number(urun.variantId), quantity: 1 };
    if (rakam) satir.properties = { Rakam: String(rakam) };
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [satir] })
    }).then(function (r) {
      if (!r.ok) {
        return r.json().then(
          function (j) {
            throw new Error((j && (j.description || j.message)) || 'Ürün eklenemedi.');
          },
          function () {
            throw new Error('Ürün eklenemedi.');
          }
        );
      }
      return r.json();
    });
  }

  /**
   * Candles first (the product page no longer offers them), then balloons;
   * everything else keeps the feed order.
   */
  function bnEkUrunSirasi(urunler) {
    function grup(p) {
      var ad = String((p && p.title) || '').toLocaleLowerCase('tr');
      if (/(^|[^a-zçğıöşü0-9])mum([^a-zçğıöşü0-9]|$)/.test(ad)) return 0;
      if (ad.indexOf('balon') !== -1) return 1;
      return 2;
    }
    return urunler
      .map(function (p, i) {
        return { p: p, g: grup(p), i: i };
      })
      .sort(function (a, b) {
        return a.g - b.g || a.i - b.i;
      })
      .map(function (x) {
        return x.p;
      });
  }

  /**
   * Render the one-tap offer tiles into a host element.
   * `adet` is how many to show (0 = all); items already in the cart are skipped.
   */
  function bnEkUrunKartlariniBas(opts) {
    var host = opts.grid;
    var kutu = opts.kutu;
    var hataEl = opts.hata;
    var adet = opts.adet === 0 ? Infinity : opts.adet || 4;
    var bitince = opts.bitince;
    if (!host || host.getAttribute('data-bn-dolu') === '1') return;

    Promise.all([bnEkUrunleriGetir(), bnSepettekiVaryantlar()]).then(function (res) {
      var urunler = (res[0] && res[0].products) || [];
      var sepette = res[1] || {};
      if (opts.sirala) urunler = bnEkUrunSirasi(urunler);
      var secilen = urunler
        .filter(function (p) {
          return p && p.variantId && !sepette[String(p.variantId)];
        })
        .slice(0, adet);
      if (!secilen.length) {
        if (kutu) kutu.hidden = true;
        return;
      }
      host.setAttribute('data-bn-dolu', '1');
      host.innerHTML = '';

      secilen.forEach(function (urun) {
        var kart = document.createElement('div');
        kart.className = 'bn-atc-upsell__item';

        if (urun.image) {
          var img = document.createElement('img');
          img.className = 'bn-atc-upsell__img';
          img.src = urun.image.replace(/(\.[a-z]+)(\?|$)/i, '_200x$1$2');
          img.alt = '';
          img.loading = 'lazy';
          img.width = 120;
          img.height = 120;
          kart.appendChild(img);
        }

        var ad = document.createElement('span');
        ad.className = 'bn-atc-upsell__name';
        ad.textContent = urun.title;
        kart.appendChild(ad);

        var fiyat = document.createElement('span');
        fiyat.className = 'bn-atc-upsell__price';
        fiyat.textContent = bnPara(Math.round(Number(urun.price) * 100), false);
        kart.appendChild(fiyat);

        var rakamAlani = null;
        var rakamGerekli = urun.digitPrompt && urun.digitPrompt !== 'NONE';
        if (rakamGerekli) {
          rakamAlani = document.createElement('input');
          rakamAlani.className = 'bn-atc-upsell__digit';
          rakamAlani.type = 'text';
          rakamAlani.inputMode = 'numeric';
          rakamAlani.maxLength = 2;
          rakamAlani.placeholder = 'Rakam';
          rakamAlani.setAttribute('aria-label', urun.title + ' için rakam');
          rakamAlani.hidden = true;
          kart.appendChild(rakamAlani);
        }

        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'bn-atc-upsell__add';
        btn.textContent = '+ Ekle';
        kart.appendChild(btn);

        btn.addEventListener('click', function () {
          if (kart.classList.contains('is-added') || kart.classList.contains('is-busy')) return;
          if (hataEl) hataEl.hidden = true;

          // A number add-on (rakam mum, rakam balon) cannot go in blind.
          if (rakamGerekli && rakamAlani.hidden) {
            rakamAlani.hidden = false;
            rakamAlani.focus();
            btn.textContent = 'Onayla';
            return;
          }
          var rakam = rakamGerekli ? String(rakamAlani.value || '').trim() : '';
          if (rakamGerekli && !/^\d{1,2}$/.test(rakam)) {
            rakamAlani.focus();
            if (hataEl) {
              hataEl.hidden = false;
              hataEl.textContent = urun.digitHint || 'Bir veya iki rakam girin.';
            }
            return;
          }

          kart.classList.add('is-busy');
          btn.textContent = 'Ekleniyor…';
          bnEkUrunEkle(urun, rakam)
            .then(function () {
              kart.classList.remove('is-busy');
              kart.classList.add('is-added');
              btn.textContent = 'Eklendi ✓';
              if (rakamAlani) rakamAlani.hidden = true;
              if (typeof bitince === 'function') bitince();
            })
            .catch(function (err) {
              kart.classList.remove('is-busy');
              btn.textContent = '+ Ekle';
              if (hataEl) {
                hataEl.hidden = false;
                hataEl.textContent = err.message || 'Ürün eklenemedi.';
              }
            });
        });

        host.appendChild(kart);
      });

      if (kutu) kutu.hidden = false;
      if (typeof opts.hazir === 'function') opts.hazir();
    });
  }

  /* ---------- Add-to-cart overlay ---------- */
  /* ---------- "Ürünler Eklendi" animation ----------
   * Plays once, then hands over to the panel. Each run gets a fresh blob URL:
   * reusing one URL would show the last frame of the previous run instead of
   * starting over.
   */
  var atcCheer = { blob: null, loading: false, stop: null };

  function warmAtcCheer(overlay) {
    var img = qs('[data-bn-atc-cheer] img', overlay);
    if (!img || atcCheer.blob || atcCheer.loading || !window.fetch || !window.URL) return;
    atcCheer.loading = true;
    fetch(img.getAttribute('data-src'))
      .then(function (r) {
        return r.ok ? r.blob() : null;
      })
      .then(function (blob) {
        atcCheer.blob = blob;
      })
      .catch(function () {
        // Without the animation the panel simply opens straight away.
      })
      .then(function () {
        atcCheer.loading = false;
      });
  }

  function playAtcCheer(overlay) {
    var box = qs('[data-bn-atc-cheer]', overlay);
    var img = box && qs('img', box);
    overlay.classList.remove('is-cheered');
    if (atcCheer.stop) atcCheer.stop();
    // Not loaded yet means the shopper would wait for it; skip instead.
    if (!img || !atcCheer.blob) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var url = URL.createObjectURL(atcCheer.blob);
    var timer = 0;
    function stop() {
      clearTimeout(timer);
      atcCheer.stop = null;
      box.hidden = true;
      img.onload = img.onerror = null;
      img.removeAttribute('src');
      URL.revokeObjectURL(url);
      if (overlay.classList.contains('is-cheering')) {
        overlay.classList.remove('is-cheering');
        overlay.classList.add('is-cheered');
      }
    }
    atcCheer.stop = stop;

    overlay.classList.add('is-cheering');
    box.hidden = false;
    img.onload = function () {
      clearTimeout(timer);
      timer = setTimeout(stop, 1000);
    };
    img.onerror = stop;
    timer = setTimeout(stop, 1600);
    img.src = url;
  }

  function openAtcOverlay(overlay) {
    overlay.hidden = false;
    overlay.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('bn-modal-open');
    playAtcCheer(overlay);
    bnEkUrunKartlariniBas({
      grid: qs('[data-bn-atc-upsell-grid]', overlay),
      kutu: qs('[data-bn-atc-upsell]', overlay),
      hata: qs('[data-bn-atc-upsell-error]', overlay),
      adet: 0,
      sirala: true,
      bitince: function () {
        // The badge in the header has to agree with what was just added.
        if (window.BnCart && typeof BnCart.refresh === 'function') {
          BnCart.refresh({ open: false });
        }
      }
    });
  }

  function closeAtcOverlay(overlay) {
    if (atcCheer.stop) atcCheer.stop();
    overlay.classList.remove('is-cheered');
    overlay.hidden = true;
    overlay.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('bn-modal-open');
  }

  /* ---------- Product recommendations ----------
   * Shopify only fills the recommendation list through the Section Rendering
   * API, so the first render is empty and the real markup is fetched here.
   */
  function initProductRecs() {
    var yer = qs('[data-bn-product-recs-yer]');
    if (!yer || yer.getAttribute('data-bn-bound')) return;
    var url = yer.getAttribute('data-url');
    if (!url) return;
    yer.setAttribute('data-bn-bound', '1');

    fetch(url)
      .then(function (r) {
        return r.ok ? r.text() : '';
      })
      .then(function (html) {
        if (!html) return;
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var bolum = tmp.querySelector('[data-bn-product-recs]');
        if (!bolum) return;
        yer.parentNode.replaceChild(bolum, yer);
        initProductCardReveal(bolum);
        initProductCardImages();
      })
      .catch(function () {
        // No recommendations is a quiet outcome, not an error the shopper sees.
      });
  }

  /* ---------- Same-day countdown in the product title bar ----------
   * The cutoff is a shop rule in Turkish time, so the clock is read in
   * Europe/Istanbul rather than the visitor's own zone. Outside the window
   * the server-rendered sentence stays as it is.
   */
  function initSameDay() {
    qsa('[data-bn-sameday]').forEach(function (el) {
      if (el.getAttribute('data-bn-bound')) return;
      var text = qs('[data-bn-sameday-text]', el);
      if (!text) return;
      el.setAttribute('data-bn-bound', '1');

      function toMinutes(value, fallback) {
        var m = /^(\d{1,2})[:.](\d{2})$/.exec(String(value || '').trim());
        return m ? Number(m[1]) * 60 + Number(m[2]) : fallback;
      }

      var start = toMinutes(el.getAttribute('data-start'), 9 * 60);
      var cutoff = toMinutes(el.getAttribute('data-cutoff'), 18 * 60);
      var liveText = el.getAttribute('data-live-text') || 'içinde sipariş verirseniz aynı gün teslim';
      var closedText = text.textContent;
      var clock;
      try {
        clock = new Intl.DateTimeFormat('en-GB', {
          timeZone: 'Europe/Istanbul',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
          hourCycle: 'h23'
        });
      } catch (e) {
        return;
      }

      function istanbulSeconds() {
        var parts = {};
        clock.formatToParts(new Date()).forEach(function (p) {
          parts[p.type] = Number(p.value);
        });
        return (parts.hour % 24) * 3600 + parts.minute * 60 + parts.second;
      }

      var lastLabel = null;
      function paint() {
        var now = istanbulSeconds();
        var left = cutoff * 60 - now;
        if (now < start * 60 || left <= 0) {
          if (lastLabel !== '') {
            text.textContent = closedText;
            el.classList.remove('is-live');
            lastLabel = '';
          }
          return;
        }
        var mins = Math.ceil(left / 60);
        var h = Math.floor(mins / 60);
        var m = mins % 60;
        var label = (h ? h + ' saat' : '') + (h && m ? ' ' : '') + (m ? m + ' dk' : '');
        if (label === lastLabel) return;
        lastLabel = label;
        var strong = document.createElement('strong');
        strong.textContent = label;
        text.textContent = '';
        text.appendChild(strong);
        text.appendChild(document.createTextNode(' ' + liveText));
        el.classList.add('is-live');
      }

      paint();
      setInterval(paint, 15000);
      document.addEventListener('visibilitychange', function () {
        if (!document.hidden) paint();
      });
    });
  }

  /* ---------- Sticky buy bar (mobile product page) ----------
   * The price box and the button sit far below the fold on a phone. The bar
   * appears once they scroll out of view and forwards the tap to the real
   * button, so the delivery gate and the missing-step scroll behave the same.
   */
  function initBuyBar() {
    var bar = qs('[data-bn-buy-bar]');
    if (!bar || bar.getAttribute('data-bn-bound')) return;
    var gercekBtn = qs('[data-bn-add-to-cart]');
    var kutu = qs('[data-bn-product-price]');
    if (!gercekBtn || !kutu) return;
    bar.setAttribute('data-bn-bound', '1');

    var barBtn = qs('[data-bn-buy-bar-btn]', bar);
    var barFiyat = qs('[data-bn-buy-bar-price]', bar);
    var whole = qs('[data-bn-price-whole]', kutu);
    var frac = qs('[data-bn-price-frac]', kutu);

    barBtn.addEventListener('click', function () {
      gercekBtn.click();
    });

    function fiyatiEsitle() {
      if (!barFiyat || !whole) return;
      barFiyat.textContent = (whole.textContent || '') + (frac ? frac.textContent || '' : '');
    }

    function durumuEsitle() {
      barBtn.classList.toggle('scd-engelli', gercekBtn.classList.contains('scd-engelli'));
      barBtn.disabled = gercekBtn.disabled;
      var etiket = gercekBtn.textContent && gercekBtn.textContent.trim();
      if (etiket) barBtn.textContent = etiket;
      // Dönen halka aria-busy üzerinden çiziliyor; bar da meşgul görünsün.
      barBtn.setAttribute('aria-busy', gercekBtn.getAttribute('aria-busy') || 'false');
    }

    // The widget repaints the price and the button as the shopper picks a slot.
    new MutationObserver(function () {
      fiyatiEsitle();
      durumuEsitle();
    }).observe(kutu, { childList: true, subtree: true, characterData: true });
    new MutationObserver(durumuEsitle).observe(gercekBtn, {
      attributes: true,
      childList: true,
      characterData: true
    });
    fiyatiEsitle();
    durumuEsitle();

    // The real button has scrolled away. Tracked separately from the keyboard:
    // iOS does not shrink the layout viewport when the keyboard opens, so a
    // fixed bottom bar stays glued to the layout bottom and lands in the
    // middle of the screen, on top of whatever the shopper is typing.
    var fiyatDisarida = false;
    var klavyeAcik = false;

    function goster() {
      var acik = fiyatDisarida && !klavyeAcik;
      bar.classList.toggle('is-visible', acik);
      bar.setAttribute('aria-hidden', String(!acik));
      document.body.classList.toggle('bn-product-sticky-acik', acik);
    }

    function klavyeOlc() {
      var vv = window.visualViewport;
      if (!vv) return false;
      // The address bar shrinks the viewport by well under this. A keyboard
      // takes a third of the screen or more.
      return window.innerHeight - vv.height > 150;
    }

    function klavyeKur(acik) {
      if (acik === klavyeAcik) return;
      klavyeAcik = acik;
      goster();
    }

    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', function () {
        klavyeKur(klavyeOlc());
      });
    }

    // visualViewport does not shrink on every phone. A focused field is the
    // other signal, and the bar has no job while the shopper is typing.
    var klavyeZaman;
    document.addEventListener('focusin', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      if (!t.closest('input, textarea, select')) return;
      var tip = (t.type || '').toLowerCase();
      // A tick does not open the keyboard. Hiding the bar on every checkbox
      // would drop it the moment an add-on is picked.
      if (tip === 'checkbox' || tip === 'radio' || tip === 'button' || tip === 'hidden' || tip === 'file' || tip === 'range') return;
      clearTimeout(klavyeZaman);
      klavyeKur(true);
    });
    document.addEventListener('focusout', function () {
      clearTimeout(klavyeZaman);
      klavyeZaman = setTimeout(function () {
        var aktif = document.activeElement;
        var tip = aktif && (aktif.type || '').toLowerCase();
        var yaziyor =
          aktif &&
          aktif.closest &&
          aktif.closest('input, textarea, select') &&
          tip !== 'checkbox' &&
          tip !== 'radio' &&
          tip !== 'button' &&
          tip !== 'hidden';
        klavyeKur(Boolean(yaziyor) || klavyeOlc());
      }, 120);
    });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            fiyatDisarida = !entry.isIntersecting;
            goster();
          });
        },
        { rootMargin: '0px 0px -40px 0px' }
      ).observe(kutu);
    } else {
      window.addEventListener('scroll', function () {
        var r = kutu.getBoundingClientRect();
        fiyatDisarida = r.bottom < 0 || r.top > window.innerHeight;
        goster();
      });
    }
  }

  /** The same one-tap offer on the cart page, where the decision is being made. */
  function initCartUpsell() {
    var kutu = qs('[data-bn-cart-upsell]');
    if (!kutu || kutu.getAttribute('data-bn-bound')) return;
    kutu.setAttribute('data-bn-bound', '1');
    bnEkUrunKartlariniBas({
      grid: qs('[data-bn-cart-upsell-grid]', kutu),
      kutu: kutu,
      hata: qs('[data-bn-cart-upsell-error]', kutu),
      adet: 16,
      hazir: function () {
        var track = qs('[data-bn-cart-upsell-grid]', kutu);
        var onceki = qs('[data-bn-cart-upsell-prev]', kutu);
        var sonraki = qs('[data-bn-cart-upsell-next]', kutu);
        if (!track || !onceki || !sonraki || track.getAttribute('data-bn-kaydir')) return;
        track.setAttribute('data-bn-kaydir', '1');
        function adim() {
          var kart = track.querySelector('.bn-atc-upsell__item');
          return kart ? kart.getBoundingClientRect().width + 10 : 160;
        }
        function guncelle() {
          var tasma = track.scrollWidth - track.clientWidth > 4;
          onceki.hidden = !tasma;
          sonraki.hidden = !tasma;
          onceki.disabled = track.scrollLeft <= 2;
          sonraki.disabled =
            track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
        }
        onceki.addEventListener('click', function () {
          track.scrollBy({ left: -adim(), behavior: 'smooth' });
        });
        sonraki.addEventListener('click', function () {
          track.scrollBy({ left: adim(), behavior: 'smooth' });
        });
        track.addEventListener('scroll', guncelle, { passive: true });
        window.addEventListener('resize', guncelle);
        guncelle();
      },
      bitince: function () {
        // Totals and the fee split are computed in Liquid, so the section has
        // to be re-rendered for the new line to be reflected.
        if (window.BnCart && typeof BnCart.get === 'function') {
          BnCart.get().then(function (cart) {
            BnCart.render(cart);
            BnCart.renderCartPage(cart);
          });
        } else {
          window.location.reload();
        }
      }
    });
  }

  function initAtcOverlay() {
    var overlay = qs('[data-bn-atc-overlay]');
    if (!overlay || overlay.getAttribute('data-bn-bound')) return;
    overlay.setAttribute('data-bn-bound', '1');

    overlay.addEventListener('click', function (e) {
      if (e.target.closest('[data-bn-atc-close]')) {
        e.preventDefault();
        closeAtcOverlay(overlay);
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !overlay.hidden) closeAtcOverlay(overlay);
    });

    // The animation stays out of the first load; start fetching it once the
    // shopper touches a product form so it is ready when the overlay opens.
    var warmEvents = ['pointerdown', 'focusin', 'submit'];
    var warmArt = function (e) {
      var t = e.target;
      if (e.type !== 'submit' && !(t && t.closest && t.closest('[data-bn-product-form]'))) return;
      warmAtcCheer(overlay);
      warmEvents.forEach(function (type) {
        document.removeEventListener(type, warmArt, true);
      });
    };
    warmEvents.forEach(function (type) {
      document.addEventListener(type, warmArt, true);
    });
  }

  /* ---------- Toast ----------
   * One live region per host. Inside an aria-modal dialog the region has to
   * live in the dialog, or screen readers ignore it while the dialog is open.
   */
  function bnToast(message, host, above) {
    host = host || document.body;
    var el = qs(':scope > .bn-toast', host);
    if (!el) {
      el = document.createElement('div');
      el.className = 'bn-toast';
      el.setAttribute('role', 'status');
      el.setAttribute('aria-live', 'polite');
      el.innerHTML =
        '<svg class="bn-toast__icon" viewBox="0 0 16 16" aria-hidden="true" focusable="false">' +
        '<path d="M3 8.4l3.2 3.2L13 4.8" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/>' +
        '</svg><span class="bn-toast__text"></span>';
      host.appendChild(el);
    }
    if (!message) return el;

    // iOS keeps fixed elements on the layout viewport, under the keyboard.
    var vv = window.visualViewport;
    var lift = vv ? Math.max(0, window.innerHeight - vv.height - vv.offsetTop) : 0;
    el.style.setProperty('--bn-toast-lift', Math.round(lift) + 'px');
    // `above` (e.g. a dialog footer) must stay readable, so sit just over it.
    var ustu = above && above.getBoundingClientRect();
    el.style.bottom = ustu && ustu.height ? Math.round(window.innerHeight - ustu.top + 12) + 'px' : '';

    clearTimeout(el._bnTimer);
    el.classList.remove('is-visible');
    qs('.bn-toast__text', el).textContent = message;
    void el.offsetWidth;
    el.classList.add('is-visible');
    el._bnTimer = setTimeout(function () {
      el.classList.remove('is-visible');
    }, 2200);
    return el;
  }

  /* ---------- Delivery fee shown once ----------
   * The speed cards already price Standart / Hemen teslim, so the fee row
   * under the time slots repeats the selected card. It is hidden only while
   * the two read the same: the row follows the server's fee preview and the
   * free / flat fee models, where the card can show a different figure, and
   * the express card's "+799 TL" is the whole fee, which only the row says.
   */
  function initDeliveryFeeDedupe(form) {
    var scope = form.closest('.bn-product-panel__body');
    if (!scope || scope.getAttribute('data-bn-fee-bound')) return;
    scope.setAttribute('data-bn-fee-bound', '1');

    function amount(el) {
      return el ? String(el.textContent || '').replace(/\s+/g, '') : '';
    }

    var queued = false;
    function sync() {
      queued = false;
      var price = amount(qs('.scd-speed__card.is-selected .scd-speed__price', scope));
      var fee = amount(qs('.scd-fee__amount:not(.is-free)', scope));
      var dup = !!price && price === fee;
      if (scope.hasAttribute('data-bn-fee-dup') !== dup) {
        scope.toggleAttribute('data-bn-fee-dup', dup);
      }
    }

    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(sync);
    }).observe(scope, {
      subtree: true,
      childList: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['class']
    });
    sync();
  }

  /* ---------- Time slot after a date is picked ----------
   * Picking a day folds the address step above into one line. The page kept
   * its scroll offset, so everything jumped up and a lone time slot ended
   * above the screen. The date field is held where the shopper tapped it,
   * then the slots are brought into view; a day with a single slot gets it
   * chosen for them.
   */
  function initDeliverySlotHelp(form) {
    var scope = form.closest('.bn-product-panel__body');
    if (!scope || scope.getAttribute('data-bn-slot-bound')) return;
    scope.setAttribute('data-bn-slot-bound', '1');

    var anchor = null;

    function isDateField(field) {
      return !!(field && qs('input[type="date"]', field));
    }

    function timeChips() {
      var fields = qsa('.scd-downstream > .scd-field', scope);
      for (var i = 0; i < fields.length; i++) {
        if (!isDateField(fields[i]) && qs('.scd-chips', fields[i])) {
          return { field: fields[i], chips: qsa('.scd-chips > .scd-chip', fields[i]) };
        }
      }
      return null;
    }

    function hold(field) {
      anchor = { el: field, top: field.getBoundingClientRect().top, until: Date.now() + 5000 };
    }

    scope.addEventListener('click', function (e) {
      var chip = e.target.closest('button.scd-chip');
      var field = chip && chip.closest('.scd-field');
      if (isDateField(field)) hold(field);
    }, true);

    scope.addEventListener('change', function (e) {
      if (e.target.matches && e.target.matches('input[type="date"]')) {
        var field = e.target.closest('.scd-field');
        if (field) hold(field);
      }
    }, true);

    // Clear of the sticky header above and the buy bar below.
    function reveal(el) {
      var r = el.getBoundingClientRect();
      var top = 110;
      var bottom = window.innerHeight - 100;
      var d = 0;
      if (r.bottom > bottom) d = r.bottom - bottom;
      if (r.top - d < top) d = r.top - top;
      if (Math.abs(d) > 2) window.scrollBy({ top: d, behavior: 'smooth' });
    }

    var queued = false;
    function sync() {
      queued = false;
      if (anchor && (Date.now() > anchor.until || !anchor.el.isConnected)) anchor = null;
      // The fold happens in the same tick as the tap, so one correction on the
      // next frame is enough; later frames must not fight the shopper's scroll.
      if (anchor && !anchor.held) {
        anchor.held = true;
        var shift = anchor.el.getBoundingClientRect().top - anchor.top;
        if (Math.abs(shift) > 2) window.scrollBy(0, shift);
      }

      var time = timeChips();
      if (!time) return;
      var only = time.chips.length === 1 ? time.chips[0] : null;
      if (only && !only.disabled && only.getAttribute('aria-pressed') !== 'true') only.click();
      if (anchor) {
        anchor = null;
        reveal(time.field);
      }
    }

    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(sync);
    }).observe(scope, { subtree: true, childList: true, attributes: true, attributeFilter: ['class'] });
  }

  /* ---------- Delivery widget wording ----------
   * The widget writes its own sentences and rewrites them on every change,
   * so they are swapped back each time they reappear.
   */
  var DELIVERY_COPY = {
    'Kurye kapıya gelebilmesi için sokak ve kapı numarası gerekli.':
      'Kuryelerimizin kapınıza gelebilmesi için sokak ve kapı numarası gerekli.',
  };

  function initDeliveryCopy(form) {
    var scope = form.closest('.bn-product-panel__body');
    if (!scope || scope.getAttribute('data-bn-copy-bound')) return;
    scope.setAttribute('data-bn-copy-bound', '1');

    function sync() {
      qsa('.scd-addr__hint', scope).forEach(function (el) {
        var text = DELIVERY_COPY[el.textContent.trim()];
        if (text) el.textContent = text;
      });
    }

    new MutationObserver(sync).observe(scope, { subtree: true, childList: true, characterData: true });
    sync();
  }

  /* ---------- Message card popup (note + greeting card) ---------- */
  function initMessageCard(form) {
    var host = qs('[data-bn-message-card]', form);
    if (!host || host.getAttribute('data-bn-bound')) return;

    var modal = qs('[data-bn-message-card-modal]', host);
    var noteStore = qs('[data-bn-message-card-note]', host);
    var nameStore = qs('[data-bn-message-card-name]', host);
    var imageStore = qs('[data-bn-message-card-image]', host);
    var codeStore = qs('[data-bn-message-card-code]', host);
    var signStore = qs('[data-bn-message-card-signature]', host);
    if (!modal || !noteStore || !nameStore || !imageStore) return;
    host.setAttribute('data-bn-bound', '1');

    // The PDP panel animates with transforms, which would make a nested
    // position:fixed modal resolve against the panel instead of the viewport.
    document.body.appendChild(modal);

    var summary = qs('[data-bn-message-card-summary]', host);
    var emptySummary = summary ? summary.textContent : 'Ekle';
    var thumb = qs('[data-bn-message-card-thumb]', host);
    var input = qs('[data-bn-message-card-input]', modal);
    var countEl = qs('[data-bn-message-card-count]', modal);
    var signInput = qs('[data-bn-message-card-signature-input]', modal);
    var toInput = qs('[data-bn-message-card-to-input]', modal);
    var toStore = qs('[data-bn-message-card-to]', host);
    var namedOpt = qs('[data-bn-message-card-named]', modal);
    var anonBtn = qs('[data-bn-message-card-anon]', modal);
    var options = qsa('[data-bn-message-card-option]', modal);

    // A card either carries the sender's name or goes out unsigned; an empty
    // name is what "İsimsiz Gönder" means, so the two can never disagree.
    function syncSign() {
      var named = !!(signInput && String(signInput.value || '').trim());
      if (namedOpt) namedOpt.classList.toggle('is-on', named);
      if (anonBtn) {
        anonBtn.classList.toggle('is-on', !named);
        anonBtn.setAttribute('aria-pressed', named ? 'false' : 'true');
      }
    }

    // "Mesaj Kartı" holds the recipient on its first line; split it back out.
    function messageBody() {
      var note = String(noteStore.value || '');
      var to = toStore ? String(toStore.value || '').trim() : '';
      if (!to) return note;
      if (note === to) return '';
      if (note.indexOf(to + '\n') === 0) return note.slice(to.length + 1);
      return note;
    }

    // One retry with a fresh URL, then a blank tile rather than a broken icon.
    qsa('.bn-message-card-option__media img', modal).forEach(function (img) {
      var inside = img.classList.contains('bn-message-card-option__inside');
      function failed() {
        if (img.getAttribute('data-bn-retried')) {
          if (inside) img.hidden = true;
          else img.parentNode.classList.add('is-broken');
          return;
        }
        img.setAttribute('data-bn-retried', '1');
        var src = img.getAttribute('src') || '';
        img.src = src + (src.indexOf('?') === -1 ? '?' : '&') + 'r=1';
      }
      img.addEventListener('error', failed);
      if (img.complete && img.getAttribute('src') && img.naturalWidth === 0) failed();
    });

    function syncTrigger() {
      var parts = [];
      var card = String(nameStore.value || '').trim();
      var note = String(noteStore.value || '').replace(/\s+/g, ' ').trim();
      var image = String(imageStore.value || '').trim();
      if (card) parts.push(card);
      if (note) parts.push(note);
      host.classList.toggle('is-filled', parts.length > 0);
      if (summary) summary.textContent = parts.length ? parts.join(' — ') : emptySummary;
      if (thumb) {
        if (card && image) {
          if (thumb.getAttribute('src') !== image) thumb.setAttribute('src', image);
          thumb.hidden = false;
        } else {
          thumb.hidden = true;
        }
      }
    }

    function markSelected(slug) {
      options.forEach(function (btn) {
        var on = !!slug && btn.getAttribute('data-card-slug') === slug;
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }

    function selectedOption() {
      for (var i = 0; i < options.length; i++) {
        if (options[i].getAttribute('aria-pressed') === 'true') return options[i];
      }
      return null;
    }

    var panel = qs('[data-bn-message-card-panel]', modal);
    var foot = qs('.bn-message-card-modal__foot', modal);
    bnToast('', modal);

    // Sized to the visual viewport so the footer stays above the iOS keyboard
    // and toolbars, which do not shrink a position:fixed inset:0 box.
    function fitViewport() {
      var vv = window.visualViewport;
      if (!vv || modal.hidden) return;
      modal.style.top = vv.offsetTop + 'px';
      modal.style.bottom = 'auto';
      modal.style.height = vv.height + 'px';
    }

    function syncCount() {
      if (!countEl || !input) return;
      var max = parseInt(input.getAttribute('maxlength'), 10) || 500;
      var left = Math.max(0, max - String(input.value || '').length);
      countEl.textContent = left + ' karakter kaldı';
      countEl.classList.toggle('is-full', left === 0);
    }

    if (input) input.addEventListener('input', syncCount);

    function open() {
      if (input) input.value = messageBody();
      syncCount();
      if (toInput) toInput.value = toStore ? toStore.value || '' : '';
      if (signInput && signStore) signInput.value = signStore.value || '';
      syncSign();
      markSelected(host.getAttribute('data-selected-card'));
      modal.hidden = false;
      modal.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('bn-modal-open');
      if (window.visualViewport) {
        fitViewport();
        window.visualViewport.addEventListener('resize', fitViewport);
        window.visualViewport.addEventListener('scroll', fitViewport);
      }
      // On touch screens an auto-focused field raises the keyboard over the cards.
      var finePointer = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
      if (input && finePointer) input.focus();
      else if (panel) panel.focus({ preventScroll: true });
    }

    // The popup is the step between "Sepete Ekle" and the cart. The delivery
    // widget adds to cart from a capture listener on the form, so this one sits
    // on document to run first. An incomplete delivery selection
    // (aria-disabled) goes straight through: the widget names what is missing.
    var pendingSubmitter = null;
    var stepDone = false;
    document.addEventListener('submit', function (e) {
      if (e.target !== form) return;
      if (stepDone) {
        stepDone = false;
        return;
      }
      var atc = qs('[data-bn-add-to-cart]', form);
      if (atc && atc.getAttribute('aria-disabled') === 'true') return;
      e.preventDefault();
      e.stopImmediatePropagation();
      pendingSubmitter = e.submitter && form.contains(e.submitter) ? e.submitter : atc;
      open();
    }, true);

    function continueToCart() {
      var submitter = pendingSubmitter;
      pendingSubmitter = null;
      if (!submitter) return;
      stepDone = true;
      if (typeof form.requestSubmit === 'function') form.requestSubmit(submitter);
      else submitter.click();
    }

    function close() {
      modal.hidden = true;
      modal.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('bn-modal-open');
      if (window.visualViewport) {
        window.visualViewport.removeEventListener('resize', fitViewport);
        window.visualViewport.removeEventListener('scroll', fitViewport);
      }
      modal.style.top = '';
      modal.style.bottom = '';
      modal.style.height = '';
    }

    // The card is stored the moment it is tapped; only the texts wait for save.
    function saveCard(chosen) {
      nameStore.value = chosen ? chosen.getAttribute('data-card-name') || '' : '';
      imageStore.value = chosen ? chosen.getAttribute('data-card-image') || '' : '';
      if (codeStore) {
        codeStore.value = chosen ? chosen.getAttribute('data-card-code') || '' : '';
      }
      if (chosen) host.setAttribute('data-selected-card', chosen.getAttribute('data-card-slug') || '');
      else host.removeAttribute('data-selected-card');
      syncTrigger();
    }

    function commit() {
      var to = toInput ? String(toInput.value || '').trim() : '';
      var body = input ? String(input.value || '').trim() : '';
      if (toStore) toStore.value = to;
      noteStore.value = to && body ? to + '\n' + body : to || body;
      if (signStore) {
        signStore.value = signInput ? String(signInput.value || '').trim() : '';
      }
      saveCard(selectedOption());
      close();
      continueToCart();
    }

    modal.addEventListener('click', function (e) {
      if (e.target.closest('[data-bn-message-card-close]')) {
        e.preventDefault();
        pendingSubmitter = null;
        close();
        return;
      }
      if (e.target.closest('[data-bn-message-card-save]')) {
        e.preventDefault();
        commit();
        return;
      }
      if (e.target.closest('[data-bn-message-card-clear]')) {
        e.preventDefault();
        if (input) input.value = '';
        if (toInput) toInput.value = '';
        if (signInput) signInput.value = '';
        syncSign();
        var hadCard = !!selectedOption();
        markSelected(null);
        saveCard(null);
        if (hadCard) bnToast('Kart seçimi kaldırıldı', modal, foot);
        return;
      }
      if (e.target.closest('[data-bn-message-card-anon]')) {
        e.preventDefault();
        if (signInput) signInput.value = '';
        syncSign();
        return;
      }
      var option = e.target.closest('[data-bn-message-card-option]');
      if (option) {
        e.preventDefault();
        // A second tap keeps the card: a double tap must not silently drop it.
        if (option.getAttribute('aria-pressed') !== 'true') {
          markSelected(option.getAttribute('data-card-slug'));
          saveCard(option);
        }
        bnToast('Kart seçimi güncellendi', modal, foot);
      }
    });

    if (signInput) signInput.addEventListener('input', syncSign);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) {
        pendingSubmitter = null;
        close();
      }
    });

    // Cart "Düzenle" refills the hidden inputs directly; this re-derives the
    // visible selection and trigger label from them.
    host.addEventListener('bn:message-card:sync', function () {
      var name = String(nameStore.value || '').trim();
      var match = null;
      for (var i = 0; i < options.length && name; i++) {
        if (options[i].getAttribute('data-card-name') === name) {
          match = options[i];
          break;
        }
      }
      if (match) host.setAttribute('data-selected-card', match.getAttribute('data-card-slug') || '');
      else host.removeAttribute('data-selected-card');
      if (codeStore) {
        codeStore.value = match ? match.getAttribute('data-card-code') || '' : '';
      }
      syncTrigger();
    });

    syncTrigger();
  }

  function initProductPhotos(form) {
    var host = qs('[data-bn-photos]', form);
    if (!host) return;
    var proxy = host.getAttribute('data-bn-upload-proxy') || '/apps/scheduled-delivery/upload';
    var errEl = qs('[data-bn-photo-error]', host);

    qsa('[data-bn-photo-input]', host).forEach(function (input) {
      if (input.getAttribute('data-bn-photo-bound')) return;
      input.setAttribute('data-bn-photo-bound', '1');
      input.addEventListener('change', function () {
        var file = input.files && input.files[0];
        if (!file) return;
        var idx = input.getAttribute('data-bn-photo-index');
        var slot = input.closest('.bn-product-photos__slot');
        var preview = slot ? qs('[data-bn-photo-preview]', slot) : null;
        var placeholder = slot ? qs('[data-bn-photo-placeholder]', slot) : null;
        var urlInput = form.querySelector(
          '[data-bn-photo-url][data-bn-photo-index="' + idx + '"]'
        );

        if (errEl) {
          errEl.hidden = true;
          errEl.textContent = '';
        }

        if (preview) {
          preview.src = URL.createObjectURL(file);
          preview.hidden = false;
        }
        if (placeholder) placeholder.hidden = true;

        var fd = new FormData();
        fd.append('file', file, file.name);

        input.disabled = true;
        fetch(proxy, { method: 'POST', body: fd })
          .then(function (r) {
            return r.json().then(function (j) {
              if (!r.ok || !j.ok) throw j;
              return j;
            });
          })
          .then(function (j) {
            if (urlInput) urlInput.value = j.url || '';
          })
          .catch(function (err) {
            if (urlInput) urlInput.value = '';
            if (preview) {
              preview.hidden = true;
              preview.removeAttribute('src');
            }
            if (placeholder) placeholder.hidden = false;
            if (errEl) {
              errEl.hidden = false;
              errEl.textContent =
                (err && err.message) || 'Fotoğraf yüklenemedi. Lütfen tekrar deneyin.';
            }
          })
          .finally(function () {
            input.disabled = false;
          });
      });
    });
  }

  function initProductCardImages() {
    qsa('[data-bn-product-card-media]').forEach(function (media) {
      var primary = qs('[data-bn-product-card-image="primary"]', media);
      if (!primary) return;

      function markLoaded() {
        media.classList.add('is-loaded');
      }

      if (primary.complete && primary.naturalWidth > 0) {
        markLoaded();
        return;
      }

      primary.addEventListener('load', markLoaded, { once: true });
      primary.addEventListener('error', markLoaded, { once: true });
    });
    initProductCardGalleries();
  }

  /* ---------- Product card photo gallery ----------
   * Touch: the track scrolls sideways under the finger and snaps per photo.
   * Mouse: the photo follows the pointer across the card, one band per photo,
   * and returns to the first when the pointer leaves. A tap or click still
   * opens the product.
   */
  function initProductCardGalleries() {
    var fineHover = window.matchMedia('(hover: hover) and (pointer: fine)');
    qsa('[data-bn-card-gallery]').forEach(function (media) {
      if (media.getAttribute('data-bn-gallery-bound')) return;
      var track = qs('[data-bn-card-track]', media);
      var dots = qsa('.bn-product-card__dot', media);
      var slides = track ? track.children : [];
      if (!track || slides.length < 2) return;
      media.setAttribute('data-bn-gallery-bound', '1');

      var current = 0;
      var warmed = false;

      // Off-screen slides sit inside a clipped scroller, where lazy loading
      // would wait until they are dragged into view and flash blank.
      function warm() {
        if (warmed) return;
        warmed = true;
        Array.prototype.forEach.call(slides, function (img) {
          img.loading = 'eager';
        });
      }

      function paint(i) {
        if (i === current) return;
        current = i;
        dots.forEach(function (d, n) {
          d.classList.toggle('is-active', n === i);
        });
      }

      function goTo(i) {
        track.scrollTo({ left: i * track.clientWidth, behavior: 'instant' });
        paint(i);
      }

      var raf = 0;
      track.addEventListener(
        'scroll',
        function () {
          if (raf) return;
          raf = requestAnimationFrame(function () {
            raf = 0;
            var w = track.clientWidth || 1;
            paint(Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / w))));
          });
        },
        { passive: true }
      );

      media.addEventListener('touchstart', warm, { passive: true, once: true });
      media.addEventListener('pointerenter', function (e) {
        if (e.pointerType === 'mouse') warm();
      });

      media.addEventListener('pointermove', function (e) {
        if (e.pointerType !== 'mouse' || !fineHover.matches) return;
        var rect = media.getBoundingClientRect();
        var ratio = (e.clientX - rect.left) / (rect.width || 1);
        var i = Math.max(0, Math.min(slides.length - 1, Math.floor(ratio * slides.length)));
        if (i !== current) goTo(i);
      });

      media.addEventListener('pointerleave', function (e) {
        if (e.pointerType !== 'mouse' || !fineHover.matches) return;
        if (current !== 0) goTo(0);
      });
    });
  }

  function rootPath() {
    return window.Shopify && Shopify.routes ? Shopify.routes.root : '/';
  }

  function isFeeLineItem(item) {
    var type = String((item && item.product_type) || '').toLowerCase();
    var title = String((item && (item.product_title || item.title)) || '').toLowerCase();
    return (
      type.indexOf('teslimat') !== -1 ||
      title.indexOf('teslimat ücreti') !== -1 ||
      title === 'standart teslimat' ||
      title === 'hızlı teslimat'
    );
  }

  function cartEditUrl(item) {
    var base = (item && item.url) || '#';
    var sep = base.indexOf('?') >= 0 ? '&' : '?';
    return base + sep + 'bn_edit=' + encodeURIComponent(item.key);
  }

  function getBnEditKey() {
    try {
      return new URLSearchParams(window.location.search || '').get('bn_edit');
    } catch (e) {
      return null;
    }
  }

  function clearBnEditParam() {
    try {
      var url = new URL(window.location.href);
      if (!url.searchParams.has('bn_edit')) return;
      url.searchParams.delete('bn_edit');
      var next = url.pathname + url.search + url.hash;
      window.history.replaceState({}, '', next);
    } catch (e) {
      /* ignore */
    }
  }

  function hasScheduledDeliveryProps(props) {
    if (!props) return false;
    return Boolean(
      props._scheduled_delivery_booking_id ||
        props._scheduled_delivery_fulfillment ||
        props._scheduled_delivery_neighborhood_id ||
        props._scheduled_delivery_branch_id ||
        props['Teslimat Tarihi']
    );
  }

  function snapshotFromCartLine(item) {
    var props = (item && item.properties) || {};
    var fulfillment = props._scheduled_delivery_fulfillment || 'delivery';
    var expressRaw = props['Hızlı Teslimat'];
    var placeName = props['Teslimat Mekanı'] || '';
    var placeAddress = props['Teslimat Adresi'] || '';
    var place = null;
    if (placeName || placeAddress) {
      place = {
        name: placeName || placeAddress,
        formattedAddress: placeAddress || placeName
      };
    }
    return {
      fulfillment: fulfillment,
      pickup: fulfillment === 'pickup',
      branchId: props._scheduled_delivery_branch_id || null,
      neighborhoodId: props._scheduled_delivery_neighborhood_id || null,
      neighborhoodName: props['Teslimat Bölgesi'] || props['Teslimat Şubesi'] || '',
      date: props['Teslimat Tarihi'] || null,
      slotStart: props._scheduled_delivery_slot_start || null,
      slotEnd: props._scheduled_delivery_slot_end || null,
      express:
        expressRaw === 'Evet' ||
        expressRaw === 'evet' ||
        expressRaw === 'true' ||
        expressRaw === '1',
      place: place,
      properties: props,
      quantity: (item && item.quantity) || 1,
      variantId: (item && item.variant_id) || null
    };
  }

  function prefillProductFormFromLine(form, product, item, snapshot) {
    if (!form || !item) return;
    var props = (snapshot && snapshot.properties) || item.properties || {};
    var variantId = item.variant_id;
    var variantInput = qs('[data-bn-variant-id]', form) || qs('[name=id]', form);
    if (variantInput && variantId) variantInput.value = String(variantId);

    if (product && product.variants && product.options) {
      var variant = null;
      for (var i = 0; i < product.variants.length; i++) {
        if (Number(product.variants[i].id) === Number(variantId)) {
          variant = product.variants[i];
          break;
        }
      }
      if (variant && variant.options) {
        qsa('[data-bn-option-select]', form).forEach(function (select, idx) {
          if (variant.options[idx] != null) select.value = variant.options[idx];
        });
      }
    }

    var qty = (snapshot && snapshot.quantity) || item.quantity || 1;
    var qtyInput = form.querySelector('[name=quantity]');
    if (!qtyInput) {
      qtyInput = document.createElement('input');
      qtyInput.type = 'hidden';
      qtyInput.name = 'quantity';
      form.appendChild(qtyInput);
    }
    qtyInput.value = String(qty);

    Object.keys(props).forEach(function (key) {
      if (!key || key.charAt(0) === '_') return;
      var val = props[key];
      if (val == null || String(val).trim() === '') return;
      var els = form.querySelectorAll('[name="properties[' + key + ']"]');
      Array.prototype.forEach.call(els, function (el) {
        if (el.type === 'checkbox' || el.type === 'radio') {
          el.checked = String(el.value) === String(val) || val === 'Evet';
        } else {
          el.value = String(val);
        }
      });
    });

    // The card image rides on an underscore-prefixed property, so the visible
    // loop above skips it; restore it explicitly before re-syncing the popup.
    var msgCard = form.querySelector('[data-bn-message-card]');
    var cardImage = form.querySelector('[data-bn-message-card-image]');
    if (cardImage) cardImage.value = String(props['_kart_gorseli'] || '');
    var cardTo = form.querySelector('[data-bn-message-card-to]');
    if (cardTo) cardTo.value = String(props['_kart_alici'] || '');
    if (msgCard) {
      msgCard.dispatchEvent(new CustomEvent('bn:message-card:sync'));
    }
  }

  function visibleProps(properties, max) {
    var out = [];
    if (!properties) return out;
    var keys = Object.keys(properties);
    var limit = typeof max === 'number' ? max : Infinity;
    for (var i = 0; i < keys.length && out.length < limit; i++) {
      var key = keys[i];
      var val = properties[key];
      if (!key || key.charAt(0) === '_') continue;
      if (val == null || String(val).trim() === '') continue;
      if (String(val).indexOf('/uploads/') !== -1) continue;
      out.push({ key: key, value: String(val) });
    }
    return out;
  }

  function cartConflicts(cart) {
    var hasPickup = false;
    var hasDelivery = false;
    var branches = {};
    var branchCount = 0;
    var items = (cart && cart.items) || [];
    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      if (isFeeLineItem(item)) continue;
      var props = item.properties || {};
      var fulfillment = props._scheduled_delivery_fulfillment || 'delivery';
      var branch = props._scheduled_delivery_branch_id || '';
      if (fulfillment === 'pickup') {
        hasPickup = true;
        if (branch && !branches[branch]) {
          branches[branch] = true;
          branchCount += 1;
        }
      } else {
        hasDelivery = true;
      }
    }
    return {
      fulfillment: hasPickup && hasDelivery,
      store: branchCount > 1
    };
  }

  var BnCart = {
    busy: false,
    cart: null,
    drawer: null,
    bound: false,
    editSession: null,

    beginEdit: function (lineKey, addonCandidates) {
      this.editSession = {
        lineKey: lineKey,
        addonCandidates: addonCandidates || [],
        addonKeys: []
      };
      return this.editSession;
    },

    replaceEditLines: function () {
      var session = this.editSession;
      this.editSession = null;
      if (!session || !session.lineKey) return Promise.resolve(null);
      var self = this;
      var keys = [session.lineKey].concat(session.addonKeys || []);
      var seen = {};
      var unique = [];
      keys.forEach(function (key) {
        if (!self.isLineKey(key) || seen[key]) return;
        seen[key] = true;
        unique.push(key);
      });
      return unique.reduce(function (chain, key) {
        return chain.then(function () {
          return self.change(key, 0);
        });
      }, Promise.resolve());
    },

    formatMoney: function (cents) {
      return bnPara(cents);
    },

    updateBadges: function (count) {
      qsa('.bn-header__badge').forEach(function (badge) {
        if (count > 0) {
          badge.textContent = String(count);
          badge.hidden = false;
        } else {
          badge.hidden = true;
        }
      });
    },

    setBusy: function (on) {
      this.busy = !!on;
      qsa('[data-bn-cart-busy]').forEach(function (el) {
        el.hidden = !on;
        el.setAttribute('aria-hidden', on ? 'false' : 'true');
      });
    },

    open: function () {
      var drawer = this.drawer || qs('[data-bn-cart-drawer]');
      if (!drawer) return;
      this.drawer = drawer;
      drawer.hidden = false;
      drawer.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('bn-cart-drawer-open');
      // Double rAF so the closed transform paints before we animate open.
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          drawer.classList.add('is-open');
        });
      });
    },

    close: function () {
      var drawer = this.drawer || qs('[data-bn-cart-drawer]');
      if (!drawer) return;
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('bn-cart-drawer-open');
      window.setTimeout(function () {
        if (!drawer.classList.contains('is-open')) drawer.hidden = true;
      }, 360);
    },

    get: function () {
      return fetch(rootPath() + 'cart.js', {
        headers: { Accept: 'application/json' }
      }).then(function (res) {
        if (!res.ok) throw new Error('cart_get_failed');
        return res.json();
      });
    },

    /**
     * A cart line key is either a variant id or "variantId:hash". Anything
     * else — an empty data attribute, a line that was already removed — made
     * Shopify answer "geçerli kimlik veya satır parametresi yok", and the
     * caller showed that sentence to the shopper as if their cart had failed.
     */
    isLineKey: function (key) {
      return /^\d+(:[a-f0-9]{32})?$/.test(String(key == null ? '' : key));
    },

    change: function (key, quantity) {
      if (!this.isLineKey(key)) {
        return Promise.reject({
          error: 'bad_line_key',
          message: 'Sepet satırı bulunamadı.'
        });
      }
      return fetch(rootPath() + 'cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({ id: key, quantity: quantity })
      }).then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok) throw data;
          return data;
        });
      });
    },

    renderLine: function (item) {
      var fee = isFeeLineItem(item);
      var img = item.image
        ? '<img class="bn-cart-line__img" src="' +
          String(item.image).replace(/"/g, '&quot;') +
          '" alt="" width="64" height="64" loading="lazy">'
        : '<span class="bn-cart-line__img bn-cart-line__img--empty"></span>';
      var propsHtml = '';
      if (!fee) {
        var props = visibleProps(item.properties);
        if (props.length) {
          propsHtml =
            '<div class="bn-cart-line__props">' +
            props
              .map(function (p) {
                return (
                  '<span class="bn-cart-line__prop">' +
                  escapeHtml(p.key) +
                  ': ' +
                  escapeHtml(p.value) +
                  '</span>'
                );
              })
              .join('') +
            '</div>';
        }
      }
      var qtyHtml = fee
        ? ''
        : '<div class="bn-cart-qty" data-bn-cart-qty>' +
          '<button type="button" class="bn-cart-qty__btn" data-bn-cart-qty-change="-1" aria-label="Azalt">−</button>' +
          '<span class="bn-cart-qty__value" data-bn-cart-qty-value>' +
          item.quantity +
          '</span>' +
          '<button type="button" class="bn-cart-qty__btn" data-bn-cart-qty-change="1" aria-label="Artır">+</button>' +
          '</div>';
      var removeHtml = fee
        ? ''
        : '<button type="button" class="bn-cart-line__remove" data-bn-cart-remove aria-label="Ürünü kaldır">×</button>';
      var url = item.url || '#';
      var editHtml = fee
        ? ''
        : '<a href="' +
          escapeHtml(cartEditUrl(item)) +
          '" class="bn-cart-line__edit">Düzenle</a>';
      return (
        '<li class="bn-cart-line' +
        (fee ? ' bn-cart-line--fee' : '') +
        '" data-bn-cart-line data-line-key="' +
        escapeHtml(item.key) +
        '" data-line-qty="' +
        item.quantity +
        '"' +
        (fee ? ' data-fee-line="true"' : '') +
        '>' +
        '<a href="' +
        escapeHtml(url) +
        '" class="bn-cart-line__media">' +
        img +
        '</a>' +
        '<div class="bn-cart-line__main">' +
        '<a href="' +
        escapeHtml(url) +
        '" class="bn-cart-line__title">' +
        escapeHtml(item.product_title || item.title || '') +
        '</a>' +
        editHtml +
        propsHtml +
        '<p class="bn-cart-line__price">' +
        this.formatMoney(item.final_line_price) +
        '</p>' +
        qtyHtml +
        '</div>' +
        removeHtml +
        '</li>'
      );
    },

    renderDrawer: function (cart) {
      var drawer = this.drawer || qs('[data-bn-cart-drawer]');
      if (!drawer) return;
      this.drawer = drawer;
      var body = qs('[data-bn-cart-drawer-body]', drawer);
      var footer = qs('[data-bn-cart-footer]', drawer);
      var countEl = qs('[data-bn-cart-count]', drawer);
      var subtotalEl = qs('[data-bn-cart-subtotal]', drawer);
      var alerts = qs('[data-bn-cart-alerts]', drawer);
      var collectionsUrl = drawer.getAttribute('data-collections-url') || '/collections/all';
      var items = (cart && cart.items) || [];
      var count = (cart && cart.item_count) || 0;

      if (countEl) {
        countEl.textContent = count > 0 ? count + ' ürün' : '';
      }

      if (alerts) {
        var conflicts = cartConflicts(cart);
        if (conflicts.fulfillment || conflicts.store) {
          var parts = [];
          if (conflicts.fulfillment) {
            parts.push('<p>Aynı sepette hem mağazadan teslim hem adrese teslim ürün var.</p>');
          }
          if (conflicts.store) {
            parts.push('<p>Sepetteki ürünler farklı mağazalardan teslim için seçilmiş.</p>');
          }
          alerts.innerHTML = '<div class="bn-cart-alert" role="alert">' + parts.join('') + '</div>';
        } else {
          alerts.innerHTML = '';
        }
      }

      if (body) {
        if (!items.length) {
          body.innerHTML =
            '<div class="bn-cart-drawer__empty" data-bn-cart-empty>' +
            '<p>Sepetiniz boş.</p>' +
            '<a href="' +
            escapeHtml(collectionsUrl) +
            '" class="bn-cart-drawer__empty-cta" data-bn-cart-close>Alışverişe devam et</a>' +
            '</div>';
        } else {
          body.innerHTML =
            '<ul class="bn-cart-drawer__items" role="list" data-bn-cart-lines">' +
            items.map(this.renderLine.bind(this)).join('') +
            '</ul>';
        }
      }

      if (footer) footer.hidden = !items.length;
      if (subtotalEl) subtotalEl.textContent = this.formatMoney((cart && cart.total_price) || 0);
    },

    renderCartPage: function (cart) {
      var page = qs('[data-bn-cart-page]');
      if (!page) return;
      // Cart page has Liquid-computed fee split — safest refresh is reload.
      if (!cart || !cart.item_count) {
        window.location.reload();
        return;
      }
      var sectionId = page.getAttribute('data-section-id');
      if (!sectionId) {
        window.location.reload();
        return;
      }
      var self = this;
      return fetch(rootPath() + 'cart?section_id=' + encodeURIComponent(sectionId))
        .then(function (res) {
          if (!res.ok) throw new Error('section_failed');
          return res.text();
        })
        .then(function (html) {
          var tmp = document.createElement('div');
          tmp.innerHTML = html;
          var next = tmp.querySelector('[data-bn-main-cart]') || tmp.firstElementChild;
          var current = page.closest('[data-bn-main-cart]') || qs('[data-bn-main-cart]');
          if (next && current && current.parentNode) {
            current.parentNode.replaceChild(next, current);
            self.initCoupons();
            // The replaced markup brings a fresh, unbound add-on block.
            initCartUpsell();
          } else {
            window.location.reload();
          }
        })
        .catch(function () {
          window.location.reload();
        });
    },

    render: function (cart) {
      this.cart = cart;
      this.updateBadges((cart && cart.item_count) || 0);
      this.renderDrawer(cart);
    },

    refresh: function (opts) {
      var self = this;
      var open = opts && opts.open;
      return this.get()
        .then(function (cart) {
          self.render(cart);
          if (open) self.open();
          return cart;
        })
        .catch(function (err) {
          console.warn('[BnCart] refresh failed', err);
        });
    },

    applyChange: function (key, quantity) {
      if (this.busy || !key) return Promise.resolve();
      var self = this;
      this.setBusy(true);
      return this.change(key, quantity)
        .then(function (cart) {
          self.render(cart);
          return Promise.resolve(self.renderCartPage(cart)).then(function () {
            return cart;
          });
        })
        .catch(function (err) {
          console.warn('[BnCart] change failed', err);
          return self.refresh();
        })
        .finally(function () {
          self.setBusy(false);
        });
    },

    initCoupons: function () {
      qsa('[data-bn-main-cart]').forEach(function (root) {
        var input = qs('[data-bn-cart-coupon-input]', root);
        var applyBtn = qs('[data-bn-cart-coupon-apply]', root);
        if (!applyBtn || !input || applyBtn.getAttribute('data-bn-bound')) return;
        applyBtn.setAttribute('data-bn-bound', '1');
        applyBtn.addEventListener('click', function () {
          var code = input.value.trim();
          if (!code) {
            input.focus();
            return;
          }
          window.location.href =
            rootPath() +
            'discount/' +
            encodeURIComponent(code) +
            '?redirect=' +
            encodeURIComponent('/cart');
        });
        input.addEventListener('keydown', function (e) {
          if (e.key === 'Enter') {
            e.preventDefault();
            applyBtn.click();
          }
        });
      });
    },

    init: function () {
      var self = this;
      this.drawer = qs('[data-bn-cart-drawer]');
      this.initCoupons();
      if (this.bound) return;
      this.bound = true;

      document.addEventListener('click', function (e) {
        var openBtn = e.target.closest('[data-bn-cart-open]');
        if (openBtn) {
          // On the cart page, never open the drawer — let the /cart link work.
          if (qs('[data-bn-cart-page]') || /\/cart\/?$/.test(window.location.pathname || '')) {
            return;
          }
          e.preventDefault();
          self.refresh({ open: true });
          return;
        }

        var closeBtn = e.target.closest('[data-bn-cart-close]');
        if (closeBtn) {
          if (closeBtn.tagName === 'A' && closeBtn.getAttribute('href') && closeBtn.getAttribute('href') !== '#') {
            self.close();
            return;
          }
          e.preventDefault();
          self.close();
          return;
        }

        if (self.busy) {
          if (e.target.closest('[data-bn-cart-qty-change], [data-bn-cart-remove]')) {
            e.preventDefault();
          }
          return;
        }

        var qtyBtn = e.target.closest('[data-bn-cart-qty-change]');
        if (qtyBtn) {
          e.preventDefault();
          var line = qtyBtn.closest('[data-bn-cart-line]');
          if (!line || line.getAttribute('data-fee-line') === 'true') return;
          var key = line.getAttribute('data-line-key');
          var current = parseInt(line.getAttribute('data-line-qty') || '1', 10) || 1;
          var delta = parseInt(qtyBtn.getAttribute('data-bn-cart-qty-change') || '0', 10) || 0;
          var next = Math.max(0, current + delta);
          self.applyChange(key, next);
          return;
        }

        var removeBtn = e.target.closest('[data-bn-cart-remove]');
        if (removeBtn) {
          e.preventDefault();
          var removeLine = removeBtn.closest('[data-bn-cart-line]');
          if (!removeLine || removeLine.getAttribute('data-fee-line') === 'true') return;
          self.applyChange(removeLine.getAttribute('data-line-key'), 0);
        }
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && self.drawer && !self.drawer.hidden) {
          self.close();
        }
      });

      document.addEventListener('bn:cart:updated', function (e) {
        var detail = (e && e.detail) || {};
        var onCartPage =
          !!qs('[data-bn-cart-page]') || /\/cart\/?$/.test(window.location.pathname || '');
        // A fresh add-to-cart gets the overlay fork instead of the drawer.
        var justAdded = !onCartPage && detail.open === true;
        var overlay = justAdded ? qs('[data-bn-atc-overlay]') : null;
        self.refresh({ open: !onCartPage && !overlay && detail.open !== false });
        if (overlay) openAtcOverlay(overlay);
      });

      window.BnCart = self;
    }
  };

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function initBnCart() {
    BnCart.init();
  }

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  // Ürün açıklaması eskiden 150px'lik bir iç kaydırma kutusuydu; mobilde
  // kaydırma çubuğu görünmediği için metnin devamı fark edilmiyordu. Artık
  // taşan açıklama kırpılıp bir "Devamını oku" düğmesiyle açılıyor.
  function initProductDesc() {
    document.querySelectorAll('[data-bn-desc]').forEach(function (kap) {
      var govde = kap.querySelector('[data-bn-desc-body]');
      var dugme = kap.querySelector('[data-bn-desc-toggle]');
      if (!govde || !dugme || kap.dataset.bnDescHazir === '1') return;
      kap.dataset.bnDescHazir = '1';

      // Taşma ancak kırpma uygulanmışken ölçülebilir: sınıf eklenip bakılıyor,
      // metin zaten kısaysa sınıf geri alınıyor.
      function olc() {
        if (dugme.getAttribute('aria-expanded') === 'true') return;
        kap.classList.add('bn-product-panel__desc--kirpik');
        var tasiyor = govde.scrollHeight - govde.clientHeight > 4;
        dugme.hidden = !tasiyor;
        if (!tasiyor) kap.classList.remove('bn-product-panel__desc--kirpik');
      }

      dugme.addEventListener('click', function () {
        var acik = dugme.getAttribute('aria-expanded') === 'true';
        dugme.setAttribute('aria-expanded', acik ? 'false' : 'true');
        kap.classList.toggle('bn-product-panel__desc--kirpik', acik);
        dugme.textContent = acik ? 'Devamını oku' : 'Daha az göster';
        if (acik) kap.scrollIntoView({ block: 'nearest' });
      });

      olc();
      // Yazı tipi sonradan yüklenince satır yüksekliği değişiyor, yeniden ölçülüyor.
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(olc);
      var zaman;
      window.addEventListener('resize', function () {
        clearTimeout(zaman);
        zaman = setTimeout(olc, 150);
      });
    });
  }

  function initBnTheme() {
    document.body.classList.add('bn-theme');
    initPageMotion();
    initOrderTracking();
    initMobileMenu();
    initPredictiveSearch();
    initMobileSearch();
    initLogoFallback();
    initCarousels();
    initScrollTop();
    initStickyHeader();
    initSectionReveal();
    initProductCardReveal();
    initProductPage();
    initProductDesc();
    initSameDay();
    initProductCardImages();
    initBnCart();
    initAtcOverlay();
    initCartUpsell();
    initBuyBar();
    initProductRecs();
  }

  ready(initBnTheme);

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target && event.target.querySelector && event.target.querySelector('[data-bn-header]')) {
      initMobileMenu();
      initPredictiveSearch();
      initMobileSearch();
    }
    initCarousels();
    initSectionReveal();
    initProductCardReveal(event.target);
    initProductCardImages();
    if (event.target && event.target.querySelector && event.target.querySelector('[data-bn-product]')) {
      initProductPage();
      initProductDesc();
      initSameDay();
    }
    if (event.target && event.target.querySelector && event.target.querySelector('[data-bn-main-cart]')) {
      initBnCart();
    }
  });
})();
